import FullScreenIcon from './FullScreenIcon';

export default FullScreenIcon;
